export default __webpack_public_path__ + "static/media/Lifebringer.557d9824.jpg";